import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLayersSingle24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconLayersSingle24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m20.017 12-7.805-4.745a.5.5 0 0 0-.52 0L3.889 12l7.805 4.745a.5.5 0 0 0 .52 0zm-7.025-6.027a2 2 0 0 0-2.079 0l-8.507 5.173a1 1 0 0 0 0 1.708l8.507 5.173a2 2 0 0 0 2.079 0l8.507-5.173a1 1 0 0 0 0-1.708z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLayersSingle24);
